import React from "react";

const Security = () => {
  // ALERT DATA
  const alerts = [
    {
      title: "Perimeter Breach",
      count: 2,
      status: "Critical",
      color: "red",
      lastDetected: "02:15 AM",
      location: "North Fence",
    },
    {
      title: "Night Movement",
      count: 5,
      status: "Warning",
      color: "yellow",
      lastDetected: "03:40 AM",
      location: "Pond Area",
    },
    {
      title: "Suspicious Activity",
      count: 1,
      status: "Warning",
      color: "yellow",
      lastDetected: "01:10 AM",
      location: "Feed Storage",
    },
    {
      title: "Restricted Zone Intrusion",
      count: 3,
      status: "Critical",
      color: "red",
      lastDetected: "12:50 AM",
      location: "Control Room",
    },
    {
      title: "Daytime Activity Check",
      count: 0,
      status: "Safe",
      color: "green",
      lastDetected: "--",
      location: "All Zones",
    },
  ];

  // AI FEATURES
  const aiFeatures = [
    "Motion Detection",
    "Restricted Zone Intrusion",
    "Night Activity Monitoring",
    "Perimeter Breach Detection",
    "Human Presence Detection",
    "Vehicle Detection",
    "Anomaly Detection",
  ];

  // RECENT EVENTS
  const recentEvents = [
    {
      time: "02:15 AM",
      event: "Perimeter breach detected",
      severity: "Critical",
    },
    {
      time: "01:10 AM",
      event: "Suspicious movement near storage",
      severity: "Warning",
    },
    {
      time: "12:50 AM",
      event: "Unauthorized entry in restricted zone",
      severity: "Critical",
    },
    {
      time: "11:30 PM",
      event: "Normal patrol movement detected",
      severity: "Info",
    },
  ];

  // SECURITY SCORE
  const securityScore = 62;

  const riskLevel =
    securityScore < 40
      ? "High Risk"
      : securityScore < 70
      ? "Moderate"
      : "Safe";

  const riskColor =
    securityScore < 40
      ? "text-red-600"
      : securityScore < 70
      ? "text-yellow-600"
      : "text-green-600";

  return (
    <div className="space-y-6">
      {/* HEADER */}
      <div className="bg-white p-6 rounded-xl shadow flex items-center">
        <h2 className="text-xl font-semibold">
          🔒 AI Security Monitoring System
        </h2>

        <span className="ml-auto bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm">
          AI Powered Surveillance
        </span>
      </div>

      {/* ALERT CARDS */}
      <div className="grid md:grid-cols-3 gap-4">
        {alerts.map((item, index) => (
          <div
            key={index}
            className="bg-white p-5 rounded-xl shadow space-y-2 border"
          >
            <h3 className="font-semibold">{item.title}</h3>

            <p className="text-2xl font-bold">{item.count}</p>

            <p className="text-xs text-gray-500">
              Last: {item.lastDetected}
            </p>
            <p className="text-xs text-gray-500">
              Location: {item.location}
            </p>

            <span
              className={`text-sm px-2 py-1 rounded-full ${
                item.color === "red"
                  ? "bg-red-100 text-red-600"
                  : item.color === "yellow"
                  ? "bg-yellow-100 text-yellow-600"
                  : "bg-green-100 text-green-600"
              }`}
            >
              {item.status}
            </span>
          </div>
        ))}
      </div>

      {/* AI FEATURES */}
      <div className="bg-white p-6 rounded-xl shadow space-y-3">
        <h3 className="font-semibold">🤖 AI Detection Capabilities</h3>

        <div className="flex flex-wrap gap-2">
          {aiFeatures.map((feature, i) => (
            <span
              key={i}
              className="bg-gray-100 px-3 py-1 rounded-full text-sm"
            >
              {feature}
            </span>
          ))}
        </div>
      </div>

      {/* RECENT EVENTS */}
      <div className="bg-white p-6 rounded-xl shadow">
        <h3 className="font-semibold mb-3">🕒 Recent Security Events</h3>

        <div className="space-y-2">
          {recentEvents.map((item, i) => (
            <div
              key={i}
              className="flex justify-between items-center text-sm border-b pb-2"
            >
              <span className="text-gray-500">{item.time}</span>

              <span className="flex-1 text-center">{item.event}</span>

              <span
                className={`px-2 py-1 rounded ${
                  item.severity === "Critical"
                    ? "bg-red-100 text-red-600"
                    : item.severity === "Warning"
                    ? "bg-yellow-100 text-yellow-600"
                    : "bg-blue-100 text-blue-600"
                }`}
              >
                {item.severity}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* SECURITY SCORE */}
      <div className="bg-white p-6 rounded-xl shadow">
        <h3 className="font-semibold mb-2">📊 Farm Security Score</h3>

        <div className="w-full bg-gray-200 h-3 rounded-full">
          <div
            className="bg-red-500 h-3 rounded-full"
            style={{ width: `${securityScore}%` }}
          ></div>
        </div>

        <p className={`mt-2 text-sm ${riskColor}`}>
          Current Risk Level: {riskLevel} ({securityScore}%)
        </p>
      </div>
    </div>
  );
};

export default Security;